<template>
  <header class="fixed top-0 left-0 right-0 h-16 bg-white shadow-md z-sticky">
    <div class="flex items-center justify-between h-full px-4">
      <!-- ハンバーガーメニューボタン（モバイルのみ） -->
      <button
        @click="toggleSideMenu"
        class="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
        aria-label="メニューを開く"
      >
        <Bars3Icon class="h-6 w-6" />
      </button>

      <!-- ロゴ（モバイル時も表示） -->
      <div class="flex items-center">
        <router-link to="/dashboard" class="flex items-center gap-2">
          <span class="text-xl font-bold text-primary-600">
            DIIIG Cloud Platform
          </span>
        </router-link>
      </div>

      <!-- 右側メニュー -->
      <div class="flex items-center gap-4">
        <!-- 通知アイコン -->
        <button
          class="relative p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
          aria-label="通知"
        >
          <BellIcon class="h-6 w-6" />
          <!-- 未読バッジ -->
          <span
            v-if="hasUnreadNotifications"
            class="absolute top-1 right-1 h-2 w-2 bg-red-500 rounded-full"
          ></span>
        </button>

        <!-- ユーザーメニュー（UserDropdown.vueを使用） -->
        <UserDropdown />
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useUiStore } from '@/stores/ui'
import { Bars3Icon, BellIcon } from '@heroicons/vue/24/outline'
import UserDropdown from '@/components/layout/UserDropdown.vue'

const uiStore = useUiStore()

const hasUnreadNotifications = computed(() => {
  // TODO: notificationStore.unreadCount > 0
  return false
})

const toggleSideMenu = () => {
  uiStore.toggleSideMenu()
}
</script>
